var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.176 3.333H7.155l2.11 2.955v19.419l-2.532 2.955h18.152l2.955-4.221H15.176V3.332z",
    fill: "url(#lol_svg__paint0_linear_233_1638)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.577 8.57A11.782 11.782 0 004.2 16.842c0 3.213 1.282 6.127 3.362 8.257l.015-.017v-2.638a10.084 10.084 0 01-1.689-5.602c0-2.072.622-3.998 1.69-5.602V8.57z",
    fill: "url(#lol_svg__paint1_linear_233_1638)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 22.752a10.085 10.085 0 001.901-5.91c0-5.311-4.087-9.668-9.287-10.097V5.052c6.134.433 10.976 5.546 10.976 11.79 0 2.153-.576 4.171-1.582 5.91H24.25z",
    fill: "url(#lol_svg__paint2_linear_233_1638)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.049 22.752A8.444 8.444 0 0016.864 8.44v14.31h5.185z",
    fill: "url(#lol_svg__paint3_radial_233_1638)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lol_svg__paint0_linear_233_1638",
    x1: 1.363,
    y1: 28.662,
    x2: 24.671,
    y2: 0.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#D29D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FFCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#E8B55D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lol_svg__paint1_linear_233_1638",
    x1: 1.363,
    y1: 28.662,
    x2: 24.671,
    y2: 0.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#D29D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FFCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#E8B55D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lol_svg__paint2_linear_233_1638",
    x1: 1.363,
    y1: 28.662,
    x2: 24.671,
    y2: 0.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF893D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#D29D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#FFCC74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#E8B55D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "lol_svg__paint3_radial_233_1638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-47.911 31.503 -1.902) scale(17.6343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119,
    stopColor: "#117D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#2FEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#117D8D"
  })))));
}
export default __webpack_public_path__ + "assets/_/_/assets/games/lol.svg";
export { SvgLol as ReactComponent };